<template lang="pug">
  .container(id='viewport')
    .layer(
      v-for="layer in playListWithContentSimple.PlayListItems",
      :style="getLayerStyle(layer)",
      :ref='`layer${layer.id}`',
      @click='selectLayer(layer, $event)',
      @dragenter="dragEnterViewport(layer, $event)",
      :class='{ focused: selectedLayer && selectedLayer.id === layer.id, dimunfocused: viewParams.dimunfocused }',
      :id="'Viewport-layer' + layer.id"
    )
    BoundingBox.boundingBox(v-if='selectedLayer', ref='BoundingBox', :selectedLayer='selectedLayer', @boxResized='boxResizedEventHandler')
</template>

<script>
import mediaUtils from '../../Common/mediaUtils.mixin'
import BoundingBox from './BoundingBox'

export default {
  props: ['playListWithContentSimple', 'selectedLayer', 'viewParams', 'scale', 'hiddenLayers', 'lockedLayers'],
  mixins: [mediaUtils],
  components: {
    BoundingBox
  },
  watch: {
    selectedLayer: async function (newVal, oldVal) {
      this.redrawBoundingBox()
    }
  },
  data () {
    return {
      errors: []
    }
  },
  methods: {
    getLayerStyle (layer) {
      if (!layer || !layer.File) return
      // const layerScreenCoordinates = this.__getZoneScreenCoordinates(layer)
      const thumbnailPath = this.getThumbnailPath(layer.File, this.viewParams.highQualityPreview ? 'high' : 'low')
      if (layer.objectFit === 'fill') {
        return `
        top: ${this.scale * layer.anchorY}px;
        left: ${this.scale * layer.anchorX}px;
        width: ${this.scale * (layer.width > 0 ? layer.width : this.playListWithContentSimple.playListLayoutWidth)}px;
        height: ${this.scale * (layer.height > 0 ? layer.height : this.playListWithContentSimple.playListLayoutHeight)}px;
        z-index: ${layer.order};
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-image: url('${thumbnailPath}');
        ${this.hiddenLayers.find(l => l.id === layer.id) ? 'opacity: 0;' : ''}
      `
      }
      let backgroundSize
      if (layer.objectFit === 'contain' || layer.objectFit === 'cover') {
        backgroundSize = layer.objectFit
      } else if (layer.objectFit === 'none') {
        if (layer.Medium.type.indexOf('Layout') === -1) {
          backgroundSize = layer.File.originalWidthPixels * this.scale + 'px ' + layer.File.originalHeightPixels * this.scale + 'px'
        } else {
          backgroundSize = layer.File.originalWidthPixels * this.scale + 'px ' + layer.File.originalHeightPixels * this.scale + 'px'
        }
      }
      return `
        top: ${this.scale * layer.anchorY}px;
        left: ${this.scale * layer.anchorX}px;
        width: ${this.scale * (layer.width > 0 ? layer.width : this.playListWithContentSimple.playListLayoutWidth)}px;
        height: ${this.scale * (layer.height > 0 ? layer.height : this.playListWithContentSimple.playListLayoutHeight)}px;
        z-index: ${layer.order};
        background-size: ${backgroundSize};
        background-position: ${layer.objectPosition};
        background-repeat: no-repeat;
        background-image: url('${thumbnailPath}');
        ${this.hiddenLayers.find(l => l.id === layer.id) ? 'opacity: 0;' : ''}
      `
    },
    selectLayer (layer, $event) {
      this.$emit('selectLayer', { layer, $event })
      this.redrawBoundingBox()
    },
    redrawBoundingBox () {
      this.$nextTick(_ => {
        if (!this.selectedLayer) return
        const layerHTMLNode = this.$refs[`layer${this.selectedLayer.layer ? this.selectedLayer.layer.id : this.selectedLayer.id}`][0]
        if (!layerHTMLNode) return
        if (this.$refs['BoundingBox']) this.$refs['BoundingBox'].__calculateResizeBox(layerHTMLNode)
      })
    },
    boxResizedEventHandler (data) {
      this.$emit('boxResized', data)
    },
    dragEnterViewport (layer, $event) {
      this.$store.dispatch('Medium/setDropAllowed', true)
    }
  },
  computed: {
  }
}
</script>
<style lang="scss" scoped>
@import "../../../../theme-m4b/src/common/var.scss";
.container {
  position: relative;
  background-color: red;
  .layer {
    position: absolute;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    &.dimunfocused {
      opacity: 0.4;
    }
    &.focused {
      opacity: 1;
      // border: 1px solid red;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Medium/LayoutEditor/Viewport.vue